import {
  AllAssemblyTemplatesForFilterSideBarQuery,
  AllAssemblyTemplatesForFilterSideBarQueryVariables,
  TemplateTypeEnum,
  useAllAssemblyTemplatesForFilterSideBarQuery,
} from '@/__generated__/graphql';
import { allAssemblyTemplates } from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { QueryHookOptions } from '@apollo/client';
import { useSetAtom } from 'jotai';

type Props = QueryHookOptions<
  AllAssemblyTemplatesForFilterSideBarQuery,
  AllAssemblyTemplatesForFilterSideBarQueryVariables
>;

export const useSelectStructure = (options?: Props) => {
  const setAllAssemblyTemplates = useSetAtom(allAssemblyTemplates);
  const structureId = useGetStructureId();
  return useAllAssemblyTemplatesForFilterSideBarQuery({
    ...options,
    variables: {
      structureId,
      type: TemplateTypeEnum.Assembly,
    },
    skip: !structureId,
    onCompleted: (response) => {
      setAllAssemblyTemplates(response.allTemplates);
      options?.onCompleted?.(response);
    },
  });
};
